// @ts-nocheck
import { useState } from "react";
import { Accordion, Card, CardBody, Col } from "reactstrap";
import CommonCardHeader from "../../../../Common/CommonCardHeader";
import CommonAccordionItem from "../Common/CommonAccordionItem";
import { SimpleAccordions } from "../../../../Constant";
import { ACCORDION_DATA, ACCORDION_LIST } from "../../../../Data/UiKit/Accordion";
import { StaticAccordion } from "./StaticAccordion";

export const SimpleAccordion = () => {
  const [open, setOpen] = useState("1");
  const toggle = (id) => (open === id ? setOpen() : setOpen(id));

  return (
    <Col sm="12" xl="6">
      <Card>
        <CommonCardHeader title={SimpleAccordions} span={ACCORDION_DATA} />
        <CardBody>
          <Accordion open={open} toggle={toggle} className="dark-accordion">  
            <StaticAccordion />
            {ACCORDION_LIST.map((data, index) => (
              <CommonAccordionItem item={data} key={index} />
            ))}
          </Accordion>
        </CardBody>
      </Card>
    </Col>
  );
};
